<div class="container-fluid" [ngClass]="question.invalid ? 'invalid-question':''">
    <mat-form-field class="w-40">
        <mat-label>Feet</mat-label>
        <input matInput type="number" class="form-control w-100" name="answer_{{name}}" placeholder="{{placeholder}}" min="3" #feetInput
            max="7" required #answerValidation="ngModel" [disabled]="summaryMode" (blur)="onClick()"
            [(ngModel)]="feetValue">
    </mat-form-field>
    <mat-form-field class="w-40">
        <mat-label>Inches</mat-label>
          <input matInput type="number" class="form-control w-100" name="answer_{{name}}" placeholder="{{placeholder}}" min="0" #inchInput
        max="11" required #answerValidation="ngModel" [disabled]="summaryMode" (blur)="onClick()"
        [(ngModel)]="inchValue">
    </mat-form-field>
    <mat-error *ngIf="question.invalid">required</mat-error>
    <mat-error *ngIf="answerValidation.errors?.minmax">Answer must be bigger or equal to 3ft or less than 7 ft 11 inches.</mat-error>    
</div>